<div class='lokos-card'>
    <ng-content></ng-content>
</div>